export type DisplayMode =
  | "twa"
  | "standalone"
  | "fullscreen"
  | "minimal-ui"
  | "browser";

export interface DisplayModeEnv {
  matches: (query: string) => boolean;
  referrer: string;
  iosStandalone: boolean;
}

const readDisplayModeEnv = (): DisplayModeEnv => ({
  matches: (query) => window.matchMedia(query).matches,
  referrer: document.referrer,
  iosStandalone:
    (navigator as Navigator & { standalone?: boolean }).standalone === true,
});

export const getDisplayMode = (env?: DisplayModeEnv): DisplayMode => {
  try {
    const { matches, referrer, iosStandalone } = env ?? readDisplayModeEnv();
    if (referrer.startsWith("android-app://")) return "twa";
    if (iosStandalone || matches("(display-mode: standalone)")) {
      return "standalone";
    }
    if (matches("(display-mode: fullscreen)")) return "fullscreen";
    if (matches("(display-mode: minimal-ui)")) return "minimal-ui";
    return "browser";
  } catch {
    return "browser";
  }
};
